import React from "react"
import { Card, Statistic, Row, Col } from "antd"
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons"

const StatCard = ({
  title,
  value,
  prefix,
  suffix,
  precision = 0,
  valueStyle,
  trend,
  trendValue,
  icon,
  loading = false,
  bordered = true,
}) => {
  const getTrendIcon = () => {
    if (!trend) return null
    return trend === "up" ? (
      <ArrowUpOutlined style={{ color: "#3f8600" }} />
    ) : (
      <ArrowDownOutlined style={{ color: "#cf1322" }} />
    )
  }

  return (
    <Card
      bordered={bordered}
      loading={loading}
      hoverable
      style={{
        borderRadius: "8px",
        height: "100%",
      }}
    >
      <Row justify="space-between" align="middle">
        <Col>
          <Statistic
            title={title}
            value={value}
            precision={precision}
            valueStyle={{
              color: trend === "up" ? "#3f8600" : trend === "down" ? "#cf1322" : "#1890ff",
              fontSize: "24px",
              fontWeight: "bold",
              ...valueStyle,
            }}
            prefix={prefix || icon}
            suffix={suffix}
          />
          {trendValue && (
            <div style={{ marginTop: "8px", fontSize: "14px", color: "#8c8c8c" }}>
              {getTrendIcon()} {trendValue}
            </div>
          )}
        </Col>
      </Row>
    </Card>
  )
}

export default StatCard
